import { render, staticRenderFns } from "./StepSixIllustration.vue?vue&type=template&id=cab72906&"
import script from "./StepSixIllustration.vue?vue&type=script&lang=js&"
export * from "./StepSixIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports